import * as React from 'react'
import * as moment from 'moment'
import { History } from 'history'
import { Route, Switch, Redirect } from 'react-router-dom'
import ProductInfoForm from '../../../../../containers/products/productedit/ProductInfo'
import ProductIntegrationForm from '../../../../../containers/products/productedit/ProductIntegration'
import ProductPricingForm from '../../../../../containers/products/productedit/ProductPricing'
import { IMap, IIntegration, IProviderServiceLevel, IProviderProductObject } from '../../../../../types'
import UIMessages from '../../../../../utils/ui-messages'
import ProductStepSelector from './ProductStepSelector'

interface IProductDetailFormProps {
  product: IProviderProductObject
  productId: string
  location: any
  integrations: IMap<IIntegration>
  serviceLevels: IMap<IProviderServiceLevel>
  fetchProduct: (productId: string) => void
}

interface IProductStepPaneProps {
  productId: string
  location: any
  product: IProviderProductObject
  integrations: IMap<IIntegration>
  serviceLevels: IMap<IProviderServiceLevel>
  selectedIntegration: { value: string; label: string } | null
}

const IProductStepPane = ({
  productId,
  location,
  product,
  integrations,
  serviceLevels,
  selectedIntegration
}: IProductStepPaneProps) => {
  const ProductInfo = ({ history }: { history?: History }) => {
    return <ProductInfoForm product={product} serviceLevels={serviceLevels} history={history} />
  }

  const ProductIntegration = ({ history }: { history?: History }) => {
    return (
      <ProductIntegrationForm
        product={product}
        integrations={integrations}
        selectedIntegration={selectedIntegration}
        history={history}
      />
    )
  }

  const ProductPricing = ({ history }: { history?: History }) => {
    if (!product) {
      return null
    }
    return <ProductPricingForm product={product} pricing={product.pricing} history={history} />
  }

  const infoRedirect = () => <Redirect to={`/products/${productId}/edit/info`} />

  return (
    <div className='mt1'>
      <ProductStepSelector pathname={location.pathname} productId={productId} />
      <div>
        <Switch>
          <Route path={`/products/${productId}/edit/info`} render={ProductInfo} />
          <Route path={`/products/${productId}/edit/pricing`} render={ProductPricing} />
          <Route path={`/products/${productId}/edit/integration`} render={ProductIntegration} />
          <Route exact={true} path={`/products/${productId}/edit`} component={infoRedirect} />
        </Switch>
      </div>
    </div>
  )
}

class ProductDetailForm extends React.Component<IProductDetailFormProps> {
  public componentDidMount() {
    const { productId } = this.props
    this.props.fetchProduct(productId)
  }

  public render() {
    const { product } = this.props
    if (!product) {
      return null
    }

    const isActive = !product.deactivationDate
      ? 'Active'
      : moment(product.deactivationDate) < moment(new Date())
      ? 'Deactivated'
      : `Will be deactivated - ${moment(product.deactivationDate).format('DD.MM.YYYY hh:mm A')}`

    const selectedIntegration =
      product && product.integrationId.length ? { value: product.integrationId, label: product.name } : null

    return (
      <section>
        <div className='flex justify-between border-top'>
          <div className='form-title-header no-border'>
            <div>
              <span className='h3 font-blue-grey'>{product.name}</span>
              <span className='ml2 h5'>
                {UIMessages.common.status}: {isActive ? UIMessages.common.active : UIMessages.common.inactive}
              </span>
            </div>
          </div>
        </div>
        <IProductStepPane selectedIntegration={selectedIntegration} {...this.props} />
      </section>
    )
  }
}

export default ProductDetailForm



// WEBPACK FOOTER //
// ./src/components/products/details/product/edit/ProductPane.tsx